import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  ChartTooltip: {
    '--triangle-left': '18px',
    '--triangle-top': '25px',
    border: '2px solid #FF0000',
    padding: '6px 10px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: 400,
    position: 'relative',
    left: '-26px',
    bottom: '50px',
    background: 'white',
    '&::after': {
      content: "''",
      display: 'block',
      height: '10px',
      width: '10px',
      backgroundColor: 'white',
      borderTop: '2px solid #FF0000',
      borderLeft: '2px solid #FF0000',
      position: 'absolute',
      top: 'var(--triangle-top)',
      left: 'var(--triangle-left)',
      transform: 'rotate(-135deg)',
      zIndex: 3,
    },
    '&::before': {
      content: "''",
      display: 'block',
      height: '4px',
      width: '14px',
      backgroundColor: 'white',
      position: 'absolute',
      top: 'calc(var(--triangle-top) + 1px)',
      left: 'calc(var(--triangle-left) - 1px)',
      zIndex: 2,
    },
  },
  container: {
    marginBottom: SPACES.xxxxxl,
  },
  graphWrapper: {
    [theme.breakpoints.up('laptop')]: {
      maxWidth: 'calc(100% - 100px)',
    },
  },
  timeframeWrapper: {
    marginLeft: SPACES.xxl,

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxxl,
  },
  statsWrapper: {
    [theme.breakpoints.down('laptop')]: {
      display: 'none',
    },
  },
}))

export default useStyles
